import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private userPermissions: string[] = [];

  constructor() { }

  hasPermission(permission: string): boolean {
    if (!this.userPermissions || this.userPermissions.length === 0) {
      const permissionsStr = localStorage.getItem('permissions');
      try {
        this.userPermissions = permissionsStr ? JSON.parse(permissionsStr) : [];
      } catch {
        this.userPermissions = [];
      }
    }
    return this.userPermissions.includes(permission);
  }
}
